import {HostListener, Injectable, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Injectable({ providedIn: 'root' })
export class BrowserService implements OnInit {
    constructor(private router: Router,) {

    }

    ngOnInit() {

    }

    startBrowser() {
        let quantity = parseInt(localStorage.getItem('tabs'));
        if (!quantity) {
            quantity = 0;
        }
        quantity++;
        localStorage.setItem('tabs', quantity.toString());

        if (quantity>1) {
            this.router.navigate(['maximal-quantity-of-opened-tabs']);
        }
    }

    checkIfNotToMuchOpenedTabs() {
        let quantity = parseInt(localStorage.getItem('tabs'));

        if (quantity>1) {
            this.router.navigate(['maximal-quantity-of-opened-tabs']);
        }
    }

    beforeCloseBrowser() {
        let quantity = parseInt(localStorage.getItem('tabs'));
        quantity--;
        localStorage.setItem('tabs', (quantity).toString());
    }

    closeBrowser() {
    }
}
